<template>
  <div class="breadcrumb" :class="[isHighlight ? '' : 'mb-2']">
    <div class="mb-4 flex w-full flex-col justify-between md:mb-0 md:flex-row md:items-center">
      <div>
        <a-breadcrumb separator=">">
          <a-breadcrumb-item
            v-for="breadcrumb in isHighlight ? breadcrumbs.slice(0, -1) : breadcrumbs"
            :key="breadcrumb.path || breadcrumb.name"
          >
            <router-link v-if="breadcrumb.path !== route.path" :to="breadcrumb.path">
              <span class="text-breadcrumb"> {{ breadcrumb.meta?.title || breadcrumb.name }}</span>
            </router-link>
            <span v-else class="text-breadcrumb">
              {{ breadcrumb.meta?.title || breadcrumb.name }}</span
            >
          </a-breadcrumb-item>
        </a-breadcrumb>
        <div v-if="isHighlight && breadcrumbs.length > 0" class="py-1 font-bold uppercase">
          {{
            breadcrumbs[breadcrumbs.length - 1]?.meta?.title ||
            breadcrumbs[breadcrumbs.length - 1]?.name
          }}
        </div>
      </div>

      <slot name="extra" />
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'CBreadCrumb',
}
</script>
<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'

interface BreadcrumbItem {
  path: string
  name?: string
  meta?: {
    title?: string
  }
}

defineProps({
  isHighlight: {
    type: Boolean,
    default: true,
  },
})

const breadcrumbs = ref<BreadcrumbItem[]>([])
const route = useRoute()

// Hàm tạo breadcrumb từ route hiện tại
const generateBreadcrumbs = () => {
  breadcrumbs.value = []

  // Lọc các route có meta.title hoặc name
  const validRoutes = route.matched.filter(item => item.meta?.title || item.name)

  validRoutes.forEach(item => {
    // Chỉ thêm các route có title hoặc name
    if (item.meta?.title || item.name) {
      breadcrumbs.value.push({
        path: item.path,
        name: item.name?.toString(),
        meta: item.meta || {},
      })
    }
  })

  // Nếu không có breadcrumb nào, tạo một breadcrumb mặc định
  if (breadcrumbs.value.length === 0 && route.meta?.title) {
    breadcrumbs.value.push({
      path: route.path,
      name: route.name?.toString(),
      meta: route.meta,
    })
  }
}

// Theo dõi thay đổi route
watch(
  () => route.fullPath,
  () => {
    generateBreadcrumbs()
  },
  { immediate: true }
)

onMounted(() => {
  generateBreadcrumbs()
})
</script>

<style lang="scss">
.breadcrumb {
  .text-breadcrumb {
    font-size: 13px;
    font-weight: 600;
  }

  .anomaly-monitoring-alert-page .ant-breadcrumb {
    .ant-breadcrumb-separator,
    .ant-breadcrumb-link .text-breadcrumb {
      color: var(--color-text-theme-dark) !important;
    }
  }
}
</style>
